/**
 * App Configuration
 * @apal/web-humanda
 */

export const appConfig = {
  name: "HUMANDA",
  fullName: "HUMANDA M&A Platform",
  themeColor: "#7C3AED",
  version: "0.0.0",
} as const;
